<template>
	<div>
		<v-app-bar app elevation="0" :color="backgroundColor" class="main-topbar " height="76" id="topbar">
			<div class="sou-container">
				<div class="d-flex flex-row align-items-center w-100">
					<div class="d-flex flex-row align-items-center main-left">
						<v-btn @click="toggleMenu()" icon class="d-block d-lg-none"><v-icon>mdi-menu</v-icon></v-btn>
						<v-btn href="/blog" plain class="px-1">
							<v-img src="@/assets/logo.png" to="/" max-width="100px" @click="scroll()" />
						</v-btn>
					</div>
					<div class="main-main">
						<v-row class="my-0">
							<v-col cols="6" xl="8" lg="8" md="8" sm="6" xs="4" class="pt-0 pb-0 w-100 flex-row justify-content-center d-none d-sm-flex">
								<router-link to="/" class="no-decoration d-flex flex-row align-items-center mr-10">
									<div class="menu-icon-wrap">
										<v-icon class="menu-icon" color="accent">
											$groups
										</v-icon>
									</div>
									<div class="bold ml-2 text-black my-auto d-none d-md-block">{{ $vuetify.lang.t('$vuetify.layout.menu.community') }}</div>
								</router-link>
								<a href="/blog" class="no-decoration d-flex flex-row align-items-center mr-10">
									<div class="menu-icon-wrap">
										<v-icon class="menu-icon" color="accent">
											$book-open
										</v-icon>
									</div>
									<div class="bold ml-2 text-black my-auto d-none d-md-block">{{ $vuetify.lang.t('$vuetify.layout.menu.blog') }}</div>
								</a>

								<a href="/home" class="no-decoration d-flex flex-row align-items-center">
									<div class="menu-icon-wrap">
										<v-icon class="menu-icon" color="accent">
											$monitor
										</v-icon>
									</div>
									<div class="bold text-black ml-2 d-none d-md-block">{{ $vuetify.lang.t('$vuetify.layout.menu.watch') }}</div>
								</a>

							</v-col>
							<v-col class="ml-auto d-flex flex-row align-items-center justify-content-right" cols="3" lg="4" md="4" sm="6">
								<v-menu
									bottom
									offset-y
									left
									:close-on-content-click="false"
									>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											color="grey"
											dark
											v-bind="attrs"
											v-on="on"
											icon
											plain
											dense
											class="pa-0"
											content-
										>
											<v-icon>mdi-magnify</v-icon>
										</v-btn>
									</template>
									<v-card>
										<v-card-text>
											<search
												v-model="search"
												class="main-search mx-auto my-auto"
											/>
										</v-card-text>
									</v-card>

									</v-menu>

								<chat-dropdown />
								<notifications-dropdown />
								<!--
								<v-btn @click="changeThemeMode()" icon class="ml-auto"><v-icon>mdi-theme-light-dark</v-icon></v-btn>
								-->
								<user-menu class="ml-auto"/>
							</v-col>
						</v-row>
					</div>
				</div>
			</div>
		</v-app-bar>
	</div>
</template>

<script>
import UserMenu from '@/components/top-bar/UserMenu'
import Search from '@/components/top-bar/Search'
import NotificationsDropdown from '@/components/notifications/NotificationsDropdown'
import ChatDropdown from '@/components/chat/ChatDropdown'
import {mapActions, mapGetters} from 'vuex';
export default {
	name: 'TopBar',
	components: {
		UserMenu,
		Search,
		NotificationsDropdown,
		ChatDropdown
	},
	data() {
		return {
			search: '',
			delayer: null
		}
	},
	computed: {
		...mapGetters({
			menu: 'application/menu',
			unreadMessagesCount: 'chat/unreadMessagesCount'
		}),
		backgroundColor: function () {
			return (this.$vuetify.theme.dark) ? 'black' : 'white'
		}
	},
	watch: {
		search: function (v) {
			if (this.delayer) {
				clearTimeout(this.delayer)
				this.delayer = null
			}
			this.delayer = setTimeout(() => {
				if (v) {
					if (this.$route.name !== 'SearchResults')
						this.$router.push({ name: 'SearchResults' })
					this.mainSearchEntireData({
						params: {
							content: v
						}
					})
				}
			}, 500)
		}
	},
	methods: {
		...mapActions('searcher', [
			'mainSearchEntireData'
		]),
		scroll() {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
		toggleMenu() {
			this.$store.commit('application/setMenu', !this.menu);

		},
		changeThemeMode() {
			this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
			localStorage.setItem('darkmode', this.$vuetify.theme.dark)
		}
	},
}
</script>

<style lang="scss">
	.main-search {
		max-width: 600px;
	}
</style>
